import(/* webpackMode: "eager", webpackExports: ["MarketingBanner"] */ "/home/pi/prod/strawman/apps/web/components/MarketingBanner/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/pi/prod/strawman/packages/ui/src/molecules/footer-detailed/style.css");
;
import(/* webpackMode: "eager" */ "/home/pi/prod/strawman/packages/ui/src/molecules/nav/nav-mobile.tsx");
;
import(/* webpackMode: "eager" */ "/home/pi/prod/strawman/packages/ui/src/molecules/nav/nav.tsx");
